module.exports = __webpack_public_path__ + "static/cintas-logo-5fd5dbe5a509c12973d0ed2155cbada6.jpg";